import type {
  CarryDocumentStatus,
  CarryFundDocumentsSummary,
} from '@/types/carryDocument';
import { formatDate } from '@/utils/formatters';

export const STATUS_PILL_CLASSES: Record<CarryDocumentStatus, string> = {
  SIGNED:
    'bg-emerald-100 text-emerald-800 dark:bg-emerald-500/15 dark:text-emerald-300',
  AWAITING_SIGNATURE:
    'bg-amber-100 text-amber-800 dark:bg-amber-500/15 dark:text-amber-300',
  MISSING: 'bg-red-100 text-red-800 dark:bg-red-500/15 dark:text-red-300',
};

export interface SignatureTally {
  signed: number;
  required: number;
  missing: number;
}

export function tallyDocuments(
  statuses: CarryDocumentStatus[]
): SignatureTally {
  return {
    signed: statuses.filter((s) => s === 'SIGNED').length,
    required: statuses.length,
    missing: statuses.filter((s) => s === 'MISSING').length,
  };
}

export function tallyStatus(tally: SignatureTally): CarryDocumentStatus {
  if (tally.signed === tally.required) return 'SIGNED';
  if (tally.missing > 0) return 'MISSING';
  return 'AWAITING_SIGNATURE';
}

export const TALLY_TEXT_CLASSES: Record<CarryDocumentStatus, string> = {
  SIGNED: 'text-foreground',
  AWAITING_SIGNATURE: 'text-amber-700 dark:text-amber-400',
  MISSING: 'text-red-700 dark:text-red-400',
};

type DocumentStatuses = CarryFundDocumentsSummary['document_statuses'];

/** Every document, or only those of one type. */
export function tallyOf(
  statuses: DocumentStatuses,
  documentTypeId?: string
): SignatureTally {
  return tallyDocuments(
    statuses
      .filter(
        (d) =>
          documentTypeId === undefined || d.document_type_id === documentTypeId
      )
      .map((d) => d.status)
  );
}

export const ANY = 'any';

export type StatusFilter = CarryDocumentStatus | typeof ANY;

export function matchesStatus(
  status: CarryDocumentStatus,
  filter: StatusFilter
): boolean {
  return filter === ANY || status === filter;
}

export function formatDocumentDate(date: string | null): string {
  return date ? formatDate(date) : '-';
}
